module.exports = __webpack_public_path__ + "static/user.svg";